import React, { Component } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const AnimatedBar = styled(motion.div)`
	background-size: 100vw;
	height: 100%;
	width: 0;
	box-shadow: inset 0px 2px 4px #ecd7fd, inset 0px -2px 4px #d148ed;
	background: linear-gradient(180deg, #c380f7 0%, #6c20c3 100%);
	box-sizing: border-box;
	border-radius: ${(p) => (p.rightCurveOnly ? '0 1vw 1vw 0' : '1vw')};
	overflow: hidden;
	text-align: left;
	position: relative;
`;
const BaseBar = styled.div`
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	overflow: hidden;
	position: relative;
	border-radius: ${(p) => (p.rightCurveOnly ? '0 2vw 2vw 0' : '2vw')};
`;
const BlackBar = styled(BaseBar)`
	-moz-box-shadow: inset 0 0 2vw #000000, 0 0.1vw 0 #ffffff40;
	-webkit-box-shadow: inset 0 0 2vw #000000, 0 0.1vw 0 #ffffff40;
	box-shadow: inset 0 0 2vw #000000, 0 0.1vw 0 #ffffff40;
	background: #2e2d27;
	background: linear-gradient(0deg, #2e2d27 0%, #21221e 100%);
	border: 0.1vw solid black;
`;
const YellowBar = styled(BaseBar)`
	-moz-box-shadow: inset 0 0 2vw rgba(0, 0, 0, 0.7);
	-webkit-box-shadow: inset 0 0 2vw rgba(0, 0, 0, 0.7);
	box-shadow: inset 0 0 2vw rgba(0, 0, 0, 0.7);
	background-color: rgba(0, 0, 0, 0.2);
`;

const ProgText = styled.div`
	position: absolute;
	top: 0;
	left: 13%;
	width: 87%;
	height: 100%;
	text-align: center;
	color: white;
	letter-spacing: 0;
	font-size: 5vw;
	display: flex;
	justify-content: center;
	align-items: center;
	text-shadow: 0 0.1em 0 rgb(0 0 0 / 40%);
`;

const ProgBarImg = styled(motion.img)`
	width: 100vw;
	min-height: 100%;
	display: block;
	position: absolute;
`;

const ProfileBar = styled(BlackBar)`
	${ProgText} {
		font-size: 4vw;
	}
`;


export class ProgressBar extends Component {
	render() {
		const {profile, yellow, rightCurveOnly, start, previous, percent, transition, onAnimationComplete} = this.props;
		const Bar = profile ? ProfileBar : yellow ? YellowBar : BlackBar;
		
		const calcWidth = value => {
			const shift = start || 0;
			const val = value || 0;
			return shift + val * (100 - shift) / 100;
		}
		return (
			<Bar rightCurveOnly={rightCurveOnly}>
				<AnimatedBar
					initial={{width: calcWidth(previous) + '%'}}
					animate={{width: calcWidth(percent) + '%'}}
					transition={transition || { delay: 0, duration: 0.5 }}
					rightCurveOnly={rightCurveOnly}
					onAnimationComplete={onAnimationComplete}
				>
					<ProgBarImg src="/assets/progress-bar.gif" />
				</AnimatedBar>
				<ProgText>{this.props.children}</ProgText>
			</Bar>
		);
	}
}
